import { useEffect, useState } from 'react';

export function useScrollY(): number {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(document.body.scrollTop);
    };

    document.body.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrollY;
}
